/* global YT */

import './section-row.scss';

/**
 * version    1.0
 * class      <type> (Section Row)
 * classdesc  Main Section Row
 */

function loadYouTubeAPI(callback) {
  if (window.YT && window.YT.Player) {
    callback();
  } else {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    document.body.appendChild(tag);
    window.onYouTubeIframeAPIReady = callback;
  }
}

export class SectionRow {
  constructor() {
    if (document.getElementById('youtubeFrame')) {
      this.initYouTubeVideoExpand();
    }
  }

  initYouTubeVideoExpand() {
    const videoContainer = document.getElementById('videoContainer');
    const iframe = document.getElementById('youtubeFrame');

    if (!videoContainer || !iframe) return;

    loadYouTubeAPI(() => {
      this.player = new YT.Player(iframe, {
        events: {
          onStateChange: (event) => {
            if (window.innerWidth >= 900) {
              if (event.data === YT.PlayerState.PLAYING) {
                videoContainer.classList.add('section-row__media--expanded');
              }

              if (event.data === YT.PlayerState.PAUSED) {
                videoContainer.classList.remove('section-row__media--expanded');
                videoContainer.classList.add('section-row__media--collapsing');

                setTimeout(() => {
                  videoContainer.classList.remove('section-row__media--collapsing');
                }, 500);
              }
            }
          },
        },
      });
    });
  }
}
